export default "__VITE_ASSET__b_M9c6zP__"